"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _Typography = _interopRequireDefault(require("../../atoms/Typography"));
var _Icon = _interopRequireDefault(require("../../atoms/Icon"));
var _Spin = _interopRequireDefault(require("../../atoms/Spin"));
var _templateObject, _templateObject2;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const translate = {
  es: {
    SUBTRACT_ARIA_LABEL: 'Disminuir cantidad del producto',
    INCREASE_ARIA_LABEL: 'Aumentar cantidad del producto',
    HANDLER_ARIA_LABEL: 'Controlador de cantidad'
  },
  en: {},
  pt: {}
};
var ActionType = /*#__PURE__*/function (ActionType) {
  ActionType["ADD"] = "ADD";
  ActionType["SUBTRACT"] = "SUBTRACT";
  return ActionType;
}(ActionType || {});
const defaultProps = {
  minQuantity: 0,
  maxQuantity: Infinity,
  disabled: false,
  loading: false,
  lang: 'es'
};
function OrderItemBottom(props) {
  const {
    initialQuantity,
    onChangeQuantity,
    minQuantity,
    maxQuantity,
    disabled,
    editable,
    loading,
    lang
  } = _objectSpread(_objectSpread({}, defaultProps), props);
  const [quantity, setQuantity] = (0, _react.useState)(initialQuantity);
  const [revertingQuantity, setRevertingQuantity] = (0, _react.useState)(false);
  const onRevertQuantity = (0, _react.useCallback)(() => setRevertingQuantity(true), []);
  const onChange = (0, _react.useCallback)(type => {
    let newQuantity = quantity;
    if (type === ActionType.ADD) newQuantity += 1;else newQuantity -= 1;
    setQuantity(newQuantity);
    onChangeQuantity === null || onChangeQuantity === void 0 || onChangeQuantity(type, newQuantity, onRevertQuantity);
  }, [quantity, setQuantity, onChangeQuantity, onRevertQuantity]);
  const onAddQuantity = (0, _react.useCallback)(() => {
    if (quantity >= maxQuantity || disabled || loading) return;
    onChange(ActionType.ADD);
  }, [onChange, disabled, loading]);
  const onSubtractQuantity = (0, _react.useCallback)(() => {
    if (quantity <= minQuantity || disabled || loading) return;
    onChange(ActionType.SUBTRACT);
  }, [onChange, disabled, loading]);
  (0, _react.useEffect)(() => {
    if (initialQuantity !== quantity && revertingQuantity) {
      setQuantity(initialQuantity);
      setRevertingQuantity(false);
    }
    if (initialQuantity !== quantity) {
      setQuantity(initialQuantity);
    }
  }, [initialQuantity, revertingQuantity]);
  return /*#__PURE__*/_react.default.createElement(Container, {
    "aria-label": translate[lang].HANDLER_ARIA_LABEL
  }, /*#__PURE__*/_react.default.createElement(IconWrapper, {
    onClick: onSubtractQuantity,
    show: editable,
    children: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("meta", {
      itemProp: "name",
      content: translate[lang].SUBTRACT_ARIA_LABEL
    }), /*#__PURE__*/_react.default.createElement(_Icon.default, {
      name: "remove",
      size: 15
    })),
    "aria-label": translate[lang].SUBTRACT_ARIA_LABEL
  }), loading ? /*#__PURE__*/_react.default.createElement(_Spin.default, {
    center: true,
    size: 14,
    type: "white"
  }) : /*#__PURE__*/_react.default.createElement(_Typography.default, {
    type: "description",
    size: 13,
    align: "center",
    dangerouslySetInnerHTML: {
      __html: "<b>".concat(quantity, "</b> unidades")
    }
  }), /*#__PURE__*/_react.default.createElement(IconWrapper, {
    onClick: onAddQuantity,
    show: editable,
    children: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("meta", {
      itemProp: "name",
      content: translate[lang].INCREASE_ARIA_LABEL
    }), /*#__PURE__*/_react.default.createElement(_Icon.default, {
      name: "add",
      size: 15
    })),
    "aria-label": translate[lang].INCREASE_ARIA_LABEL
  }));
}
const Container = _styled.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  height: 32px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 8px 15px;\n  border-radius: 10px;\n  background-color: ", ";\n\n  .material-icons {\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n    -webkit-touch-callout: none;\n    -webkit-user-select: none;\n    -khtml-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n  }\n\n  p[type='description'] {\n    margin: auto;\n    line-height: normal;\n  }\n\n  @media screen and (min-width: 768px) {\n    p[type='description'] {\n      font-size: 16px !important;\n    }\n\n    .material-icons {\n      font-size: 20px;\n    }\n  }\n"])), _ref => {
  let {
    theme
  } = _ref;
  return theme.colors.NEUTRAL.SIDE;
});
const IconWrapper = _styled.default.button(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  background: none;\n  border: none;\n  padding: 0px;\n\n  ", "\n"])), _ref2 => {
  let {
    show
  } = _ref2;
  return !show && "display: none;";
});
var _default = exports.default = OrderItemBottom;